<template>
    <div class="conversations" :style="{width:width+'px', height:height+'px'}">
        <div class="header">
            <div class="go-back">
                <div class="fal fa-chevron-left"></div>
            </div>
            <div class="info-box">
                <div class="name">
                    Олжик Маратович
                </div>
                <div class="status">
                    last seen Saturday
                </div>
            </div>
            <div class="controls">
                <div class="fal fa-ellipsis-v"></div>
            </div>
            <div class="avatar">OM</div>
        </div>
        <div class="body">
            <div class="message" v-for="msg in messages" :class="{my:msg.owner === my_id}">
                <div class="date my">{{msg.date}}</div>
                <div class="bubble">
                    {{msg.text}}
                </div>
                <div class="date">{{msg.date}}</div>
            </div>
        </div>
        <div class="footer">
            <div class="attach">
                <div class="fal fa-paperclip"></div>
            </div>
            <div class="message-box">
                <input type="text" class='input-message' placeholder="Write a message...">
                <div class="emoji">
                    <div class="fal fa-smile"></div>
                </div>
            </div>
            <div class="send">
                <div class="fal fa-arrow-right"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {

    name: 'conversations',
    props: {
        width: { type: [Number,String], default: 'auto' },
        height: { type: [Number,String], default: 'auto' },
    },
    data() {
        return {
            my_id: "2",
            messages: [{
                text: "Ну может и не фейе",
                date: "11:24pm",
                owner: "1"
            }, {
                text: "пообщался",
                date: "11:24pm",
                owner: "2"
            }, {
                text: "пообщя",
                date: "11:24pm",
                owner: "2"
            }, {
                text: "пооблся",
                date: "11:24pm",
                owner: "2"
            }, {
                text: "2 часа общался",
                date: "11:24pm",
                owner: "1"
            }, {
                text: "все нормально)",
                date: "11:24pm",
                owner: "2"
            }, {
                text: "ok",
                date: "11:24pm",
                owner: "1"
            }, {
                text: "пообщался",
                date: "11:24pm",
                owner: "2"
            }, {
                text: "пообщя",
                date: "11:24pm",
                owner: "2"
            }, {
                text: "пооблся",
                date: "11:24pm",
                owner: "2"
            }, {
                text: "2 часа общался",
                date: "11:24pm",
                owner: "1"
            }, {
                text: "все нормально)",
                date: "11:24pm",
                owner: "2"
            }, {
                text: "ok",
                date: "11:24pm",
                owner: "1"
            }, {
                text: "пообщался",
                date: "11:24pm",
                owner: "2"
            }, {
                text: "пообщя",
                date: "11:24pm",
                owner: "2"
            }, {
                text: "пооблся",
                date: "11:24pm",
                owner: "2"
            }, {
                text: "2 часа общался",
                date: "11:24pm",
                owner: "1"
            }, {
                text: "все нормально)",
                date: "11:24pm",
                owner: "2"
            }, {
                text: "ok",
                date: "11:24pm",
                owner: "1"
            }, {
                text: "пообщался",
                date: "11:24pm",
                owner: "2"
            }, {
                text: "пообщя",
                date: "11:24pm",
                owner: "2"
            }, {
                text: "пооблся",
                date: "11:24pm",
                owner: "2"
            }, {
                text: "2 часа общался",
                date: "11:24pm",
                owner: "1"
            }, {
                text: "все нормально)",
                date: "11:24pm",
                owner: "2"
            }, {
                text: "ok",
                date: "11:24pm",
                owner: "1"
            }]
        }
    }
}
</script>
<style lang="css" scoped>

.conversations{
	overflow:hidden;
}
.header {
    background: #466f92;
    background: linear-gradient(to right, #3023AE, #C86DD7);
    color: white;
    padding: 4px;
    overflow: hidden;
}

.name {
    font-weight: bold;
    font-size: 18px;
}

.status {
    font-size: 12px;
}

.controls {
    font-size: 36px;
    padding: 4px 16px;
}

.info-box {
    display: inline-block;
    padding: 6px 0 0 8px;
    width: calc(100% - 116px);
}

.go-back {
    font-size: 24px;
    padding: 10px 8px;
}

.go-back:hover {
    cursor: pointer;
    background: rgba(0, 0, 0, 0.25);
}

.avatar {
    border-radius: 100%;
    width: 48px;
    height: 48px;
    background: #e6c761;
    display: inline-block;
    padding-top: 14px;
    font-size: 18px;
    text-align: center;
}

.controls,
.info-box,
.go-back,
.avatar {
    float: left;
}






.body {
    height: calc(100% - 105px);
    overflow-y: scroll;
}

.message {
    vertical-align: middle;
}

.message .bubble {
    padding: 4px 8px;
    background: #efefef;
    margin: 4px 8px;
    display: inline-block;
    border-radius: 2px;
}

.date.my {
    display: none;
}

.message.my {
    text-align: right;
}

.message.my .date {
    display: none;
}

.message.my .date.my {
    display: inline-block;
}

.message.my .bubble {
    background: #deedff;
}


.date {
    font-size: 12px;
    color: grey;
    display: inline-block;
}










.footer {
    padding: 8px 0;
    vertical-align: top;
    overflow:hidden;
}

.attach {
    font-size: 24px;
    float: left;
    padding: 3px 6px;
    margin: 0 6px;
    border-radius: 4px;
}

.attach:hover {
    cursor: pointer;
    background: rgba(0, 0, 0, 0.15);

}

.message-box {
    background: #ededed;
    padding: 2px 4px;
    border-radius: 2px;
    float: left;
    width: calc(100% - 94px);
}

.input-message {
    border-color: transparent;
    background: transparent;
    outline: none;
    margin: 2px;
    vertical-align: top;
    width:calc( 100% - 30px );
}

.emoji {
    display: inline-block;
    font-size: 22px;
    margin: 2px;
    float: right;
}

.send {
    font-size: 24px;
    padding: 3px 6px;
    margin: 0 6px;
    float: left;
    border-radius: 4px;
}

.send:hover {
    cursor: pointer;
    background: rgba(0, 0, 0, 0.15);

}
</style>